import React from 'react';
import { Container, Typography, Box, Grid, CircularProgress } from '@mui/material';
import Banner from "../../components/Banner";
import AlternatingInfoBlock from "../../components/AlternatingInfoBlock";
import { fetchAllBlogPosts } from './../../components/wordpressUtils';
import BannerHub from './../../components/BannerHub.js';
import CarouselArticulos from './../../components/CarouselArticulos';
import { useEffect, useState } from 'react';
import InfoCardSection from './../../components/InfoCardSection';
import CallToActionSection from "./../../components/CallToActionSection.js";
import { keyframes } from '@mui/system';

export default function Familia() {
  const [isLoadingArticles, setIsLoadingArticles] = useState(true);
  const [wordpressArticles, setWordpressArticles] = useState([]);

  const rotateBackground = keyframes`
  0% { transform: rotate(0deg); }
  50% { transform: rotate(45deg); }
  100% { transform: rotate(0deg); }
`;

  const rotateBackgroundReverse = keyframes`
  0% { transform: rotate(0deg); }
  50% { transform: rotate(-45deg); }
  100% { transform: rotate(0deg); }
`;
  const familiaEmpresarialItems = [
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349494/ebm/fe-family-icon_xrndfb.png",
      alt: "Familia empresarial definición",
      text: "Grupo familiar que posee la mayoría del capital de una o varias empresas y comparte una visión de continuidad."
    },
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349494/ebm/fe-future-icon_odxdsh.png",
      alt: "Enfoque Familia empresarial",
      text: "En la cohesión, unidad familiar y en la continuidad del legado."
    },
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349494/ebm/fe-balance-icon_blnxnf.png",
      alt: "Principal preocupación Familia empresarial",
      text: "Equilibrio entre los intereses familiares y empresariales, así como la capacitación de las nuevas generaciones."
    },
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349494/ebm/fe-wealth-icon_dotbmn.png",
      alt: "Estrategia Familia empresarial",
      text: "Gestión del patrimonio, manteniendo una visión a largo plazo y valores compartidos."
    },
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349494/ebm/fe-community-icon_qbszyy.png",
      alt: "Desafiós principales Familia empresarial",
      text: "Mantener la armonía y la cohesión familiar mientras se garantiza la sostenibilidad del negocio."
    }
  ];
  const empresaFamiliarItems = [
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349494/ebm/ef-company-icon_nu5z2d.png",
      alt: "Empresa familiar definición",
      text: "Organización en la que la propiedad está concentrada en un grupo familiar."
    },
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349495/ebm/ef-decision-icon_hhjxbz.png",
      alt: "Enfoque Empresa familiar",
      text: "En el control de las decisiones estratégicas y operativas, y en la sucesión generacional."
    },
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349495/ebm/ef-pedestrian-icon_w33bpe.png",
      alt: "Principal preocupación Empresa familiar",
      text: "La transferencia de la propiedad y el control a las siguientes generaciones."
    },
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349495/ebm/ef-warning-icon_mks76r.png",
      alt: "Estrategia Empresa familiar",
      text: "Tomar decisiones... basadas en los valores familiares, pero a menudo enfrentando conflictos internos."
    },
    {
      icon: "https://res.cloudinary.com/dhoyyqszi/image/upload/v1745349495/ebm/ef-avoidance-icon_tkmtmn.png",
      alt: "Desafíos principales Empresa familiar",
      text: "Evitar conflictos familiares y gestionar la mezcla de relaciones familiares con las decisiones empresariales."
    }
  ];



  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingArticles(true);
        const wpArticles = await fetchAllBlogPosts();
        setWordpressArticles(wpArticles);
      } catch (err) {
        console.error('Error al obtener artículos:', err);
      } finally {
        setIsLoadingArticles(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container sx={{ margin: '0', padding: '0 !important', maxWidth: '100vw !important' }}>
      <Banner
        backgroundImage="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745342077/ebm/banner-fam_esvhns.png"
        titleBackgroundColor="#84BFCB"
        extraContent={
          <Box
            sx={{

              bottom: 0,
              left: 0,
              maxWidth: { xs: '350px', sm: '500px', md: '600px' },
              paddingLeft: { xs: '2.2rem', sm: '7.2rem' },
              padding: "10px",
              textAlign: "justify",
              placeContent: 'inherit'

            }}
          >
            <Typography sx={{ color: 'white', fontSize: { xs: '14px', sm: '16px' }, textAlign: 'left', textShadow: '0px 2px 10px rgb(0,0,0,0.5)', letterSpacing: 2 }}>EJES DE ACCIÓN</Typography>
          </Box>
        }
        title="La familia"
        subtitle={
          <Box sx={{
            padding: { xs: "2rem 2rem", sm: "2.2rem 7.2rem" },
            textAlign: { sm: "justify" },
            width: '100%', marginBottom: '14vh'
          }}>
            <Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' }, textShadow: '0px 2px 10px rgb(0,0,0,0.5)', maxWidth: { sm: '450px', md: '600px' } }}>
              Brindamos acompañamiento a familias empresarias en su tránsito hacia la profesionalización, <b>promoviendo relaciones armónicas y una visión compartida.
              </b></Typography>
          </Box>
        }
        variant="bottom-left"

      />
      <Box sx={{
        backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1745341945/ebm/background-dark_agpwkj.png)', backgroundRepeat: "no-repeat",
        backgroundSize: { xs: 'cover', lg: "100%" }, backgroundPosition: { xs: "top center", lg: "top left" }, backgroundColor: 'black', color: 'white', paddingBottom: { lg: '1em' }
      }}>
        <Grid container sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'space-around' }, alignItems: 'center', textAlign: 'justify', py: 8 }}>
          <Grid item xs={10} md={6} lg={5} >
            <Box sx={{ pl: { md: 4 } }}>
              <Typography sx={{ fontWeight: 100, fontSize: '14px' }}>
                Una <b>familia empresaria</b> está compuesta por los miembros de la familia propietaria que mantienen una relación de parentesco,  pueden o no estar activamente involucrados en la empresa.
                <br></br>
                <br></br>
                Las familias empresarias a menudo enfrentan desafíos en su camino hacia el éxito. Es aquí donde nuestro expertise marca la diferencia. Ofrecemos soluciones  que abordan estos retos, asegurando que las familias preserven la armonía y alcancen el éxito empresarial y patrimonial.
                <br></br>
                <br></br>
                <Typography sx={{ color: '#D4A76A', fontStyle: 'italic' }}>Descubre cómo nuestros servicios, te ayudarán a superar los desafíos únicos de estos sistemas.</Typography>

              </Typography>
            </Box>
          </Grid>

          <Grid item xs={10} md={6} sx={{ display: 'flex', justifyContent: 'center', marginTop: { xs: 8, md: '-50px' } }}>
            <Grid container sx={{ px: 4, maxWidth: '650px', gap: { xs: 4, sm: 0 } }}>

              {/* Primer circulo */}
              <Grid item xs={12} sm={6} lg={5} sx={{ marginBottom: { xs: 0, md: '50px' }, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                <Box sx={{
                  position: "relative",
                  overflow: "hidden",
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  width: { xs: '280px', sm: '35vw', md: '22vw' },
                  height: { xs: '280px', sm: '35vw', md: '22vw' },
                  maxWidth: '280px',
                  maxHeight: '280px',
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1745341617/ebm/circle-fam-1_w6hd4f.png)',
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    animation: `${rotateBackground} 17s ease-in-out infinite alternate`
                  }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-end', zIndex: 2 }}>
                    <Typography sx={{ fontSize: { xs: '42px', lg: '50px' }, lineHeight: 1, fontWeight: 900 }}>77</Typography>
                    <Typography sx={{ fontSize: { xs: '22px', lg: '32px' }, lineHeight: 1.2, fontWeight: 900 }}>%</Typography>
                  </Box>
                  <Typography sx={{ fontSize: { xs: '10px', md: '9px', lg: '10px' }, zIndex: 2, fontWeight: 100, px: { xs: 6, md: 5, xl: 8 } }}>
                    Experimenta dificultades derivadas de la falta de separación de dirección y propiedad.
                  </Typography>
                </Box>
              </Grid>

              {/* Segundo circulo */}
              <Grid item xs={12} sm={6} lg={5} sx={{ marginTop: { xs: 0, md: '-250px' }, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                <Box sx={{
                  position: "relative",
                  overflow: "hidden",
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  width: { xs: '280px', sm: '35vw', md: '19vw' },
                  height: { xs: '220px', sm: '30vw', md: '19vw' },
                  maxWidth: '220px',
                  maxHeight: '220px',
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1745341617/ebm/circle-fam-2_fdy7wl.png)',
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    animation: `${rotateBackgroundReverse} 17s ease-in-out infinite alternate-reverse`
                  }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-end', zIndex: 2 }}>
                    <Typography sx={{ fontSize: { xs: '42px', lg: '50px' }, lineHeight: 1, fontWeight: 900 }}>7</Typography>
                    <Typography sx={{ fontSize: { xs: '22px', lg: '32px' }, lineHeight: 1.2, fontWeight: 900 }}>%</Typography>
                  </Box>
                  <Typography sx={{ fontSize: { xs: '10px', md: '9px', lg: '10px' }, zIndex: 2, fontWeight: 100, px: { xs: 6, md: 5, xl: 8 } }}>
                    Presentan un nivel de avance en planes de sucesión familiar.
                  </Typography>
                </Box>
              </Grid>

              {/* Tercer circulo */}
              <Grid item xs={12} sm={6} lg={5} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                <Box sx={{
                  position: "relative",
                  overflow: "hidden",
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  width: { xs: '280px', sm: '35vw', md: '19vw' },
                  height: { xs: '220px', sm: '30vw', md: '19vw' },
                  maxWidth: '220px',
                  maxHeight: '220px',
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1745341617/ebm/circle-fam-3_smdp1j.png)',
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    animation: `${rotateBackgroundReverse} 17s ease-in-out infinite alternate`
                  }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-end', zIndex: 2 }}>
                    <Typography sx={{ fontSize: { xs: '42px', lg: '50px' }, lineHeight: 1, fontWeight: 900 }}>66</Typography>
                    <Typography sx={{ fontSize: { xs: '22px', lg: '32px' }, lineHeight: 1.2, fontWeight: 900 }}>%</Typography>
                  </Box>
                  <Typography sx={{ fontSize: { xs: '10px', md: '9px', lg: '10px' }, zIndex: 2, fontWeight: 100, px: { xs: 6, md: 5, xl: 8 } }}>
                    Lleva temas de familia a la empresa, y viceversa.
                  </Typography>
                </Box>
              </Grid>

              {/* Cuarto circulo */}
              <Grid item xs={12} sm={6} lg={5} sx={{ marginTop: { xs: 0, md: '-200px' }, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                <Box sx={{
                  position: "relative",
                  overflow: "hidden",
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  width: { xs: '280px', sm: '35vw', md: '22vw' },
                  height: { xs: '280px', sm: '35vw', md: '22vw' },
                  maxWidth: '280px',
                  maxHeight: '280px',
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1745341617/ebm/circle-fam-4_vcmrux.png)',
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    animation: `${rotateBackgroundReverse} 17s ease-in-out infinite alternate-reverse`
                  }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-end', zIndex: 2 }}>
                    <Typography sx={{ fontSize: { xs: '42px', lg: '50px' }, lineHeight: 1, fontWeight: 900 }}>10</Typography>
                    <Typography sx={{ fontSize: { xs: '22px', lg: '32px' }, lineHeight: 1.2, fontWeight: 900 }}>%</Typography>
                  </Box>
                  <Typography sx={{ fontSize: { xs: '10px', md: '9px', lg: '10px' }, zIndex: 2, fontWeight: 100, px: { xs: 6, md: 5, xl: 8 } }}>
                    De las empresas manifiesta avances importantes en temas de institucionalización.
                  </Typography>
                </Box>
              </Grid>

            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ background: 'linear-gradient(45deg, rgba(56, 65, 61, 0.32), rgba(136, 136, 136, 0.1))', p: 2, py: 10, display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
        <Typography sx={{ textAlign: 'center', pb: 4, color: '#282828', fontSize: { xs: '1.4rem', md: '1.8rem' } }}>¿<b>Familia Empresaria</b> o Empresa Familiar?</Typography>
        <Grid container sx={{ display: 'flex', justifyContent: 'center', gap: { xs: 4, lg: 0 } }}>
          <Grid item  >
            <InfoCardSection
              title="FAMILIA EMPRESARIA"
              titleColor="#84BFCB"
              lineColor="#84BFCB"
              items={familiaEmpresarialItems}
            />
          </Grid>
          <Grid item sx={{ display: { xs: 'none', lg: 'flex' }, flexDirection: 'column', justifyContent: 'flex-end', pb: 4, }}>
            <Grid container sx={{ color: 'white', textAlign: 'center', flexDirection: 'column', gap: 4.1 }}>
              <Grid item sx={{ backgroundColor: '#35889E', width: '100%', minWidth: '196px', py: '8px' }}>
                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>DEFINICIÓN</Typography>
              </Grid>
              <Grid item sx={{ backgroundColor: '#35889E', width: '100%', minWidth: '196px', py: '8px' }}>
                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>ENFOQUE</Typography>
              </Grid>
              <Grid item sx={{ backgroundColor: '#35889E', width: '100%', minWidth: '196px', py: '8px' }}>
                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>PRINCIPAL PREOCUPACIÓN</Typography>
              </Grid>
              <Grid item sx={{ backgroundColor: '#35889E', width: '100%', minWidth: '196px', py: '8px' }}>
                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>ESTRATEGIA</Typography>
              </Grid>
              <Grid item sx={{ backgroundColor: '#35889E', width: '100%', minWidth: '196px', py: '8px' }}>
                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>DESAFÍOS PRINCIPALES</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item >
            <InfoCardSection
              title="EMPRESA FAMILIAR"
              titleColor="#3B7F79"
              lineColor="#3B7F79"
              items={empresaFamiliarItems}
            />


          </Grid>
        </Grid>
      </Box>
      <CallToActionSection
        gradient="linear-gradient(to right, #2f2f2f, #1a1a1a)"
        title="¡Preserva la armonía y asegura el éxito de tu familia empresaria!"
        description={`Contacta a nuestros expertos y da el siguiente paso hacia un <strong>legado duradero</strong>.`}
        buttonText="Agenda una cita"
        buttonLink="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2eVA-xB-1w0bULc68zTMQ5dWAK4AP9Ow9P6r6QQl4DFZkqdrRENaPyWxRyLbAtrmocL908Fkfl"
        image={'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745430079/ebm/familia-callToAction_lovwds.png'}
      />
      <Box sx={{ pt: 10 }}>
        <Typography sx={{ color: '#84BFCB', textAlign: 'center', fontSize: '32px' }}>Nuestros <b>servicios</b></Typography>
        <Typography sx={{ letterSpacing: 1, textAlign: 'center', fontSize: '20px' }}>PROTEGIENDO LO QUE MÁS IMPORTA</Typography>

        <AlternatingInfoBlock
          titleColor='#84BFCB'
          title="Protocolo Familiar"
          subtitle="EL CAMINO HACIA UNA GESTIÓN FAMILIAR ORDENADA"
          description={
            <>
              Documento que establece los valores, reglas y principios que guían la relación entre los miembros de la familia, la(s) empresa(s) y el patrimonio común.
              Su propósito es fortalecer la unidad, evitar conflictos futuros y proteger el legado familiar.<br />
              <br />
              El protocolo facilita que todos trabajen alineados, definiendo cómo interactuar, tomar decisiones y gestionar la familia de forma ordenada, armoniosa y sostenible.
            </>
          }

          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745436286/ebm/familia-img-1_scxyhn.png"
        />

        <AlternatingInfoBlock
          titleColor='#84BFCB'
          title="Family Office"
          subtitle="PROFESIONALIZA LA DIRECCIÓN DE TU LEGADO"
          description={
            <>
              Servicio integral que permite a la familia empresaria preservar, consolidar y expandir su legado a lo largo de generaciones, manteniendo los valores y la visión que los definen.<br />
              <br />
              Más allá de la gestión centralizada de activos e inversiones, establece una estructura profesional para la toma de decisiones objetivas, asegurando que cada decisión esté alineada tanto con los objetivos familiares como con los del patrimonio.<br />
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1749066892/ebm/2149383205_2_won2ao.png"
          reverse // invierte imagen y texto
        />

        <AlternatingInfoBlock
          titleColor='#84BFCB'
          title="Gobernanza Familiar"
          subtitle="FORTALECIENDO LA DIRECCIÓN Y TOMA DE DECISIONES"
          description="Proporciona un marco de principios, estructuras y procesos que ayudan a la familia empresaria a alcanzar su visión y objetivos. Este sistema de gobernanza se basa en tres pilares: la Asamblea Familiar, que promueve la unidad y facilita decisiones comunes; el Consejo de Familia, que dirige acciones para proteger y aumentar el patrimonio; y los Comités y Comisiones, que apoyan al Consejo en funciones específicas para fortalecer el gobierno familiar."
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1749066889/ebm/2149383205_3_rhl9of.png"
        />

        <AlternatingInfoBlock
          titleColor='#84BFCB'
          title="Coaching de sucesores"
          subtitle="PARA UNA TRANSICIÓN PROFESIONAL Y RESPONSABLE"
          description={
            <>
              Mediante un diagnóstico se evalúa el perfil, la personalidad, los intereses y las capacidades de cada sucesor, con base en este análisis, se diseña un plan de formación que les permite adquirir los conocimientos necesarios para su futuro rol como accionistas, consejeros o tomadores de decisiones.
              <br /><br />
              El objetivo es facilitar una transición generacional ordenada, contribuir a la continuidad del proyecto empresarial y contribuir a la profesionalización de la familia.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783099737/ebm/2149383205_4_wgpo4z.png"
          reverse
        />
      </Box>
      {/* Carrusel con artículos de WordPress */}
      <Box sx={{
        backgroundColor: 'white',
        pb: 10,
        pt: 8,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        borderBottom: '1px solid #E0E0E0'
      }}>
        <Typography sx={{
          py: 4,
          color: '#0A6274',
          fontSize: { xs: '1.6rem', md: '2rem' },
          fontWeight: 600,
          textAlign: 'center'
        }}>
          Explora nuestros <b>últimos insights</b>
        </Typography>

        {isLoadingArticles ? (
          <Box sx={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress color="primary" />
          </Box>
        ) : wordpressArticles.length > 0 ? (
          <CarouselArticulos wpData={wordpressArticles} />
        ) : (
          <Typography>No hay artículos disponibles</Typography>
        )}
        <BannerHub></BannerHub>
      </Box>
    </Container>
  );
}
